import { useEffect } from "react";
import * as teams from "@microsoft/teams-js";


export default function B2CPopupEnd() {
useEffect(() => {
const run = async () => {
  try {
    // Initialize Teams before using any Teams APIs
    await teams.app.initialize();
    
    const token = new URLSearchParams(window.location.search).get("token");
    if (token) localStorage.setItem("access_token", token);

    // Now we can safely use Teams authentication APIs
    teams.authentication.notifySuccess(token || "OK");
  } catch (err) {
    console.error("Failed to initialize Teams or notify success:", err);
  }
};

run();
}, []);


return <div>Completing login…</div>;
}